import { Assistant } from "@inrev/assistant";
import type { AssistantConversationId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { useReportLoadError } from "../../../utils/useReportLoadError";
import { assistantCitationsQueryKey } from "../assistant.keys";

const NO_ITEMS: Assistant.Dtos.Citation.Resolve.Item[] = [];
const NO_IDS: Assistant.Tools.EvidenceId[] = [];

/**
 * Labels for the records an answer cites, read from the database rather than the answer, and the
 * cited records that no longer exist.
 */
export const useFetchAssistantCitations = (
	conversationId: AssistantConversationId | undefined,
	evidenceIds: readonly Assistant.Tools.EvidenceId[],
) => {
	const { post } = useRequest();
	const ids = evidenceIds.slice(0, Assistant.Dtos.Citation.Resolve.MAX_CITATIONS);

	const query = useQuery({
		queryKey: assistantCitationsQueryKey(conversationId, ids),
		queryFn: async () =>
			post<Assistant.Dtos.Citation.Resolve.Response>(
				`/v2/admin/assistant/conversations/${conversationId}/citations`,
				{ ids } satisfies Assistant.Dtos.Citation.Resolve.Request,
			),
		enabled: conversationId !== undefined && ids.length > 0,
	});
	useReportLoadError(query.error);

	return { citations: query.data?.items ?? NO_ITEMS, missing: query.data?.missing ?? NO_IDS };
};
